import React from 'react';
import PropTypes from 'prop-types';
import FaClose from 'react-icons/lib/fa/close';
import Player from '../Player';


const VideoLayout = ({ onCloseClick, title, body, videos }) => {
  const [video] = videos;
  return (
    <div className="modal-video-layout">
      <header className="modal-header pb-0" style={{ border: 0 }}>
        <h2 className="heading-display">{title}</h2>
        <div className="modal-close" onClick={onCloseClick}>
          <FaClose />
        </div>
      </header>
      <div className="modal-content">
        <div className="body-copy mb-3" dangerouslySetInnerHTML={{ __html: body }} />
        <div className="mb-3">
          <Player video={video.vimeoUrl || video.vimeoId} slug={video.slug} />
        </div>
        <h6>{video.title}</h6>
        <div className="caption" dangerouslySetInnerHTML={{ __html: video.body }} />
      </div>
    </div>
  );
};

VideoLayout.propTypes = {
  title: PropTypes.string,
  body: PropTypes.string,
  videos: PropTypes.arrayOf(PropTypes.object),
};

export default VideoLayout;



// WEBPACK FOOTER //
// ./src/components/Modal/VideoLayout.js